<template>
    <modal
        id="company-asset-assign-modal"
        size="large"
        v-model="showModal"
        :title="$t('assign')"
        @submit="handleSubmit"
        :scrollable="false"
        body-class="assign-modal-body"
        :loading="loading"
        :preloader="preloader"
    >
        <form ref="form" @submit.prevent="handleSubmit">
            <app-form-group-selectable
                :label="$t('employee')"
                type="search-select"
                v-model="formData.employee_id"
                list-value-field="employee_name"
                :placeholder="$t('search_and_select_an_employee')"
                :required="true"
                :error-message="$errorMessage(errors, 'employee_id')"
                :fetch-url="`${apiUrl.TENANT_SELECTABLE_USER}?without=admin&employee=only&with_auth=yes`"
            />

            <app-form-group
                :label="$t('start_time')"
                type="date"
                date-mode="dateTime"
                v-model="formData.start_time"
                :placeholder="$t('punch_in_time')"
                :required="true"
                :error-message="$errorMessage(errors, 'start_time')"
            />

            <app-form-group
                :label="$t('end_time')"
                type="date"
                date-mode="dateTime"
                v-model="formData.end_time"
                :placeholder="$t('punch_out_time')"
                :required="true"
                :error-message="$errorMessage(errors, 'end_time')"
            />

            <app-form-group
                :label="$t('remark')"
                type="textarea"
                form-group-class="mb-0"
                :text-area-rows="7"
                v-model="formData.remark"
                :placeholder="$textAreaPlaceHolder('remark')"
                :error-message="$errorMessage(errors, 'remark')"
            />
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {formatDateTimeForServer} from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name: "CompanyAssetAssignModal",
    mixins: [ModalMixin, FormHelperMixins],
    props: {
        assetId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            formData: {
                employee_id: null,
                start_time: '',
                end_time: '',
                remark: ''
            }
        }
    },
    watch: {
        value(value) {
            this.showModal = value;
            if (value) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.loading = false;
            this.errors = {};
            this.formData = {
                employee_id: null,
                start_time: '',
                end_time: '',
                remark: '',
            };
        },
        handleSubmit() {
            this.loading = true;
            this.errors = {};

            const payload = {
                company_asset_id: this.assetId,
                employee_id: this.formData.employee_id,
                start_time: formatDateTimeForServer(this.formData.start_time),
                end_time: this.formData.end_time ? formatDateTimeForServer(this.formData.end_time) : null,
                remark: this.formData.remark,
            };

            this.axiosPost({
                url: this.apiUrl.ASSET_ASSIGNS,
                data: payload, 
            }).then(({response}) => {
                this.resetForm();
                $('#company-asset-assign-modal').modal('hide');
                this.$emit('input', false);
            }).catch(({response}) => {
                this.errors = response?.data?.errors || {};
                this.$toastr.e('', response?.data?.message || this.$t('failed_response'));
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>
